export const getDependentAge = (birthday: string | undefined) => {
  const birthDate = new Date(String(birthday));
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();
  return age;
};

export const isDependentDisabled = ({
  dependentId,
  dependentsOnCoverage,
  canIncrease,
  canDecrease,
  eligibleDependents,
  requiredDependents,
}: {
  dependentId: number;
  dependentsOnCoverage: number[];
  canIncrease?: boolean;
  canDecrease?: boolean;
  eligibleDependents?: number[];
  requiredDependents?: number[];
}) => {
  return (
    (dependentsOnCoverage.includes(dependentId) && !canDecrease) ||
    (!dependentsOnCoverage.includes(dependentId) && !canIncrease) ||
    (eligibleDependents && !eligibleDependents.includes(dependentId)) ||
    (requiredDependents && requiredDependents.includes(dependentId))
  );
};
